import React, { useState, useEffect } from 'react';
import { get, post, put } from '../utils/api';
import { useAuth } from '../context/AuthContext';

export default function Customers() {
  const { hasPermission } = useAuth();
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [modal, setModal] = useState(null);

  const load = () => {
    setLoading(true);
    get('/customers?limit=200').then(d => setCustomers(d.data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const filtered = customers.filter(c =>
    !search || c.name.toLowerCase().includes(search.toLowerCase()) || (c.phone||'').includes(search)
  );

  return (
    <div>
      <div className="flex-between mb-lg">
        <h2 className="page-title">Customers</h2>
        {hasPermission('customers:write') && (
          <button className="btn btn-primary" onClick={() => setModal({})}>+ Add Customer</button>
        )}
      </div>
      <div className="search-bar">
        <input placeholder="Search customers..." value={search} onChange={e => setSearch(e.target.value)} />
      </div>
      <div className="tbl-wrap">
        {loading ? <div className="spinner"></div> : (
          <table>
            <thead><tr><th>Name</th><th>Phone</th><th>Email</th><th>Type</th><th>Notes</th><th></th></tr></thead>
            <tbody>
              {filtered.length === 0
                ? <tr><td colSpan="6"><div className="empty-state"><h3>No customers yet</h3></div></td></tr>
                : filtered.map(c => (
                  <tr key={c.id}>
                    <td style={{fontWeight:500}}>{c.name}</td>
                    <td>{c.phone||'—'}</td><td>{c.email||'—'}</td>
                    <td><span className="badge b-grey">{c.type}</span></td>
                    <td className="text-muted text-sm">{c.notes||'—'}</td>
                    <td>{hasPermission('customers:write') &&
                      <button className="btn btn-ghost btn-sm" onClick={() => setModal(c)}>Edit</button>}
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        )}
      </div>
      {modal !== null && (
        <CustomerModal customer={modal} onClose={() => setModal(null)} onSaved={() => { setModal(null); load(); }} />
      )}
    </div>
  );
}

function CustomerModal({ customer, onClose, onSaved }) {
  const isEdit = customer?.id;
  const [form, setForm] = useState(customer || { name:'',phone:'',email:'',address:'',type:'retail',notes:'' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const submit = async () => {
    if (!form.name) { alert('Customer name is required'); return; }
    // Duplicate check by phone
    if (!customer && form.phone) {
      const existing = await get('/customers?limit=200').then(d=>(d.data||[]).find(c=>c.phone===form.phone)).catch(()=>null);
      if (existing) {
        if (!window.confirm('A customer with phone '+form.phone+' already exists: "'+existing.name+'". Add anyway?')) return;
      }
    }
    if (!form.name) { setError('Name required'); return; }
    setSaving(true);
    try {
      if (isEdit) await put('/customers/'+customer.id, form);
      else await post('/customers', form);
      onSaved();
    } catch (err) { setError(err.message); } finally { setSaving(false); }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-hdr">
          <span className="modal-title">{isEdit ? 'Edit Customer' : 'New Customer'}</span>
          <button className="btn btn-ghost btn-sm" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          {error && <div className="alert alert-error mb-md">{error}</div>}
          <div className="form-row">
            <div className="form-group"><label className="form-label">Full Name *</label>
              <input className="form-control" value={form.name} onChange={e => setForm({...form,name:e.target.value})} /></div>
            <div className="form-group"><label className="form-label">Phone</label>
              <input className="form-control" value={form.phone||''} onChange={e => setForm({...form,phone:e.target.value})} /></div>
          </div>
          <div className="form-row">
            <div className="form-group"><label className="form-label">Email</label>
              <input type="email" className="form-control" value={form.email||''} onChange={e => setForm({...form,email:e.target.value})} /></div>
            <div className="form-group"><label className="form-label">Type</label>
              <select className="form-control" value={form.type} onChange={e => setForm({...form,type:e.target.value})}>
                <option value="retail">Retail</option><option value="corporate">Corporate</option>
                <option value="event_planner">Event Planner</option><option value="bride">Bride</option>
              </select></div>
          </div>
          <div className="form-group"><label className="form-label">Address</label>
            <input className="form-control" value={form.address||''} onChange={e => setForm({...form,address:e.target.value})} /></div>
          <div className="form-group"><label className="form-label">Notes</label>
            <textarea className="form-control" rows={2} value={form.notes||''} onChange={e => setForm({...form,notes:e.target.value})} /></div>
        </div>
        <div className="modal-ftr">
          <button className="btn btn-outline" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={submit} disabled={saving}>
            {saving ? 'Saving...' : (isEdit ? 'Save Changes' : 'Add Customer')}
          </button>
        </div>
      </div>
    </div>
  );
}
